var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-divider',{staticClass:"mx-2 my-auto",staticStyle:{"height":"16px"},attrs:{"inset":"","vertical":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }